import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
  routes: [{
      path: '/',
      name: 'home',
      component: () => import('./views/home/index.vue')
    },
    {
      path: '/aboutJiuju',//关于玖聚
      name: 'aboutJiuju',
      component: () => import('./views/aboutJiuju/index.vue')
    },
    {
      path: '/professionalField',//专业领域
      name: 'professionalField',
      component: () => import('./views/professionalField/index.vue')
    },
    {
      path: '/jiujuTeam',//玖聚团队
      name: 'jiujuTeam',
      component: () => import('./views/jiujuTeam/index.vue')
    },
    {
      path: '/jiujuTeam/personalInfo',//玖聚团队-内容
      name: 'personalInfo',
      component: () => import('./views/jiujuTeam/personalInfo.vue')
    },
    {
      path: '/contactUs',//联系我们
      name: 'contactUs',
      component: () => import('./views/contactUs/index.vue')
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(res => res.meta.requireAuth)) {
    if (to.fullPath === from.fullPath) {
      next(false);  // 阻止重复导航
    } else {
      next();  // 正常导航
    }
  } else {
    next()
  }
})

export default router
